export enum RatingCancelChargesEnum {
  cts992 = 'CTS992'
};

export enum RatingCancelChargesErrorMessageEnum {
  cancelChargesErrorMessage = 'This Bill needs to be manually rated for canceling charges.',
  tariffCts992ErrorMessage = 'This Bill needs to be manually due to the Tariff code is CTS992.',
};
